export default __webpack_public_path__ + "static/media/whatsapp.ee272212.svg";